module.exports = __webpack_public_path__ + "static/media/ico-pie.c2509f85.svg";